
angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.profile', {
    url: 'profile/?showTutorial?section',
    templateUrl: '/views/partials/clinic/profile.html',
    controller: 'ClinicProfileCtrl',
    resolve: {
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Profile - ' + clinic.name + ' - Opencare');
      },
      questions: function(QuestionService) {
        return QuestionService.listClinicQuestions();
      },
      allFeatures: function(clinic, FeatureService, OCClinicUtil, OpencareConstants) {
        var specialties = OCClinicUtil.getProviderSpecialties(clinic);
        var hasDentist = _.chain(specialties).map('id')
          .includes(OpencareConstants.specialtyId.DENTIST)
          .value();
        return hasDentist ? FeatureService.list(OpencareConstants.specialtyId.DENTIST) : [];
      },
      allProcedures: async (ProcedureService) => {
        return await ProcedureService.listAvailable();
      },
      clinicProcedures: async (clinic, ProcedureService) => {
        return await ProcedureService.listForClinic(clinic.id);
      },
      allFinancingOptions: async (FinancingOptionService) => {
        return await FinancingOptionService.listAvailable();
      },
      clinicFinancingOptions: async (clinic, FinancingOptionService) => {
        return await FinancingOptionService.listForClinic(clinic.id);
      },
      aiAssistantEnabled: async (clinic, ClinicService) => {
        return await ClinicService.getClinicAiAssistantEnabled(clinic.id);
      },
      allSafetyProcedures: function() {
        return [{
          id: 'airPurificationSystems',
          name: 'Air Purification Systems',
        }, {
          id: 'patientPreScreening',
          name: 'Patient Pre-Screening',
        }, {
          id: 'additionalPPE',
          name: 'Additional personal protective equipment (PPE) face shields, masks, gowns, gloves',
        }, {
          id: 'plexiglassAtReceptionArea',
          name: 'Plexiglass at reception area',
        }, {
          id: 'prePayAppointments',
          name: 'Pre-pay Appointments',
        }, {
          id: 'telehealthOptions',
          name: 'Tele-health Options',
        }, {
          id: 'appointmentSpacing',
          name: 'Appointment spacing to eliminate patient interaction',
        }, {
          id: 'temperatureCheck',
          name: 'Temperature check upon entering',
        }, {
          id: 'closedDoor',
          name: 'Closed door for each operatory',
        }, {
          id: 'hospitalGradeDisinfectant',
          name: 'Hospital grade disinfectant between each patient',
        }, {
          id: 'additionalSanitizationStations',
          name: 'Additional sanitization stations available',
        }];
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicProfileCtrl', function(
  $scope,
  $filter,
  $timeout,
  $window,
  $document,
  $stateParams,
  OCAddressUtil,
  OCMapUtil,
  OCModalUtil,
  questions,
  allFeatures,
  allSafetyProcedures,
  allProcedures,
  clinicProcedures,
  allFinancingOptions,
  clinicFinancingOptions,
  aiAssistantEnabled,
  ClinicService,
  ProcedureService,
  FinancingOptionService,
  OCValidationUtil,
  OCStringUtil,
  QuestionService,
  OpencareConstants,
  UserService,
  clinic,
  CurrentUser,
  PhoneUtils,
) {
  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.PROFILE_MANAGER,
    pageName: clinic.name,
    content: {
      view: 'practice',
      is_real_practice: String(!CurrentUser.isImpersonated()),
    },
    practiceId: clinic.id,
    userId: CurrentUser.getUser().id,
  });

  if ($stateParams.showTutorial) {
    OCModalUtil.showModal('clinicTutorial');
  }

  $scope.scrollToSection = () => {
    const sectionElement = $document.find(`[data-section-id='${$stateParams.section}']`)[0];
    if (!sectionElement) {
      return;
    }
    sectionElement.scrollIntoView();
  };

  var map = null;
  var marker = null;
  var phoneTokens = $scope.clinic.phone ? $scope.clinic.phone.split('x') : [];

  const isUSClinic = OCStringUtil.isUnitedStates($scope.clinic.address.country);

  $scope.clinic.metadata = $scope.clinic.metadata || {};
  $scope.questions = questions;
  $scope.responsesByQuestion = _.indexBy($scope.clinic.questionResponses, function(response) {
    return response.question.id;
  });

  $scope.shouldShowAiAssistantBanner = Boolean(aiAssistantEnabled);

  $scope.userEntered = {
    addressString: OCAddressUtil.addressAsString($scope.clinic.address),
    addressDetails: null,
    phoneNumber: phoneTokens[0],
    phoneExtension: phoneTokens[1],
  };

  $scope.isClinicCanadian = OCStringUtil.isCanada($scope.clinic.address.country);

  // All US practices are assumed to have assignment enabled, so we only show this for Canadian practices
  $scope.showAssignmentWidget = (
    $scope.isClinicCanadian
    && $scope.clinic.providers
      .map((provider) => provider.doctor)
      .map((doctor) => doctor.specialties)
      .flat()
      .some((specialty) => specialty.id === OpencareConstants.specialtyId.DENTIST)
  );

  $scope.featuresControl = {
    enabled: allFeatures.length > 0,
    listOfAll: allFeatures,
    listOfSelected: $scope.clinic.features,
    isEditing: false,

    startEdit: function() {
      $scope.featuresControl.isEditing = true;
    },

    stopEdit: function() {
      $scope.featuresControl.isEditing = false;
    },

    submit: function(selectedFeatures) {
      return ClinicService.updateFeatures($scope.clinic.id, _.map(selectedFeatures, 'id')).then(function() {
        $scope.featuresControl.listOfSelected = selectedFeatures;
        $scope.$emit('reloadClinic');
      })
        .finally(function() {
          $scope.featuresControl.stopEdit();
        });
    },
  };

  $scope.procedurePricingControl = {
    allProcedures,
    clinicProcedures,
    isEnabled: allProcedures.length > 0,
    isEditing: false,

    startEdit: () => {
      $scope.procedurePricingControl.isEditing = true;
    },

    stopEdit: () => {
      $scope.procedurePricingControl.isEditing = false;
    },

    submit: async (procedureInputs) => {
      $scope.procedurePricingControl.clinicProcedures =
        await ProcedureService.updateForClinic($scope.clinic.id, procedureInputs);
      $scope.procedurePricingControl.stopEdit();
    },
  };

  $scope.financingControl = {
    allFinancingOptions,
    clinicFinancingOptions,
    isEnabled: isUSClinic && allFinancingOptions.length > 0,
    isEditing: false,

    startEdit: () => {
      $scope.financingControl.isEditing = true;
    },

    stopEdit: () => {
      $scope.financingControl.isEditing = false;
    },

    submit: async (financingOptionIds) => {
      $scope.financingControl.clinicFinancingOptions =
        await FinancingOptionService.updateForClinic($scope.clinic.id, financingOptionIds);
      $scope.financingControl.stopEdit();
    },
  };

  $scope.inHouseMembershipControl = {
    isEnabled: isUSClinic,
    isEditing: false,

    startEdit: () => {
      $scope.inHouseMembershipControl.isEditing = true;
    },

    stopEdit: () => {
      $scope.inHouseMembershipControl.isEditing = false;
    },

    submit: async (inHouseMembership) => {
      await ClinicService.updateClinic($scope.clinic, { inHouseMembership });

      // Reassigning gives the directive a new reference to pick up.
      $scope.clinic.inHouseMembership = inHouseMembership;
      $scope.inHouseMembershipControl.stopEdit();
      $scope.$emit('reloadClinic');
    },
  };

  $scope.safetyProceduresControl = {
    enabled: allSafetyProcedures.length > 0,
    listOfAll: allSafetyProcedures,
    listOfSelected: _.filter(allSafetyProcedures, function(safetyProcedure) {
      return _.get($scope.clinic, ['covidSafetyProceduresMap', safetyProcedure.id]) === true;
    }),
    isEditing: false,

    startEdit: function() {
      $scope.safetyProceduresControl.isEditing = true;
    },

    stopEdit: function() {
      $scope.safetyProceduresControl.isEditing = false;
    },

    submit: function(selectedSafetyProcedures) {
      var covidSafetyProceduresMap = {};

      _.each($scope.safetyProceduresControl.listOfAll, function(safetyProcedure) {
        var selectedSafetyProcedure = _.find(selectedSafetyProcedures, function(selectedSafetyProcedure) {
          return selectedSafetyProcedure.id === safetyProcedure.id;
        });

        covidSafetyProceduresMap[safetyProcedure.id] = selectedSafetyProcedure
          ? selectedSafetyProcedure.selected
          : safetyProcedure.selected;
      });

      return ClinicService.updateClinic($scope.clinic, {
        covidSafetyProceduresMap,
      }).then(function() {
        $scope.safetyProceduresControl.listOfSelected = selectedSafetyProcedures;
        $scope.$emit('reloadClinic');
      })
        .finally(function() {
          $scope.safetyProceduresControl.stopEdit();
        });
    },
  };

  $window.onresize = function() {
    if (marker) {
      OCMapUtil.setMapMarkerPosition(map, marker, marker.getPosition().lat(), marker.getPosition().lng());
    }
  };

  $scope.$watch('userEntered.addressDetails', function() {
    if ($scope.userEntered.addressDetails && $scope.userEntered.addressDetails.geometry) {
      var location = $scope.userEntered.addressDetails.geometry.location;
      OCMapUtil.setMapMarkerPosition(map, marker, location.lat(), location.lng());
    }
  }, true);

  $scope.$watch('clinic.metadata.acceptsDentalInsuranceOnAssignment', function() {
    ClinicService.updateClinic($scope.clinic, {
      metadata: {
        acceptsDentalInsuranceOnAssignment: $scope.clinic.metadata.acceptsDentalInsuranceOnAssignment,
      },
    });
  });

  $scope.$watch('clinic.metadata.isMemberIdOptional', function() {
    ClinicService.updateClinic($scope.clinic, {
      metadata: {
        isMemberIdOptional: $scope.clinic.metadata.isMemberIdOptional,
      },
    });
  });

  $scope.checkAddress = function() {
    var addressDetails = $scope.userEntered.addressDetails;
    if (addressDetails && !OCAddressUtil.map.checkPlace(addressDetails)) {
      return 'Please select a street address from the dropdown.';
    }
  };

  $scope.checkName = (name) => {
    if (!name.trim()) {
      return 'Please enter a name.';
    }
  };

  $scope.checkWebsite = function(website) {
    if (website && !OCValidationUtil.isValidWebsite(website)) {
      return 'Please enter a valid URL.';
    }
  };

  $scope.checkPhone = function(phone) {
    if (!OCValidationUtil.isValidPhoneNumber(phone)) {
      return 'Please enter a valid phone number.';
    }
  };

  $scope.updateClinic = function() {
    if (!$scope.checkAddress()) {
      var clinicLocation = OCAddressUtil.map.parsePlace($scope.userEntered.addressDetails);
      if (clinicLocation) {
        clinicLocation.address.suite = $scope.clinic.address.suite;
        angular.extend($scope.clinic, clinicLocation);
      }
    }
    $scope.clinic.phone = $scope.clinicPhone();
    OCMapUtil.setMapMarkerPosition(map, marker, $scope.clinic.latitude, $scope.clinic.longitude);
    $scope.clinic.website = OCValidationUtil.urlFormat($scope.clinic.website);

    return ClinicService.updateClinic($scope.clinic, {
      phone: $scope.clinic.phone,
      website: $scope.clinic.website,
      description: $scope.clinic.description,
    }).then(function(clinic) {
      $scope.clinic = clinic;
      $scope.$emit('reloadClinic');
    });
  };

  $scope.updateClinicPhone = function() {
    return $scope.updateClinic().then(function() {
      if (!$scope.needPhoneVerification()) {
        return false;
      }
      return OCModalUtil.showModal(
        'clinicPhoneVerify',
        {
          clinic: $scope.clinic,
          modalType: 'UPDATE',
        },
      );
    })
      .then(function(code) {
        if (!code) {
          return;
        }
        ClinicService.verifyPhone($scope.clinic.id, code).then(function() {
          $scope.clinic.phoneVerified = true;
          $scope.$emit('reloadClinic');
        });
      });
  };

  $scope.getQuestionResponse = function(question) {
    if (!$scope.responsesByQuestion[question.id]) {
      $scope.responsesByQuestion[question.id] = {
        response: '',
      };
    }
    return $scope.responsesByQuestion[question.id];
  };

  $scope.saveQuestionResponse = function(question, responseText) {
    if ($scope.waitingQuestionResponse) {
      return;
    }
    $scope.waitingQuestionResponse = true;
    return QuestionService.respond(question.id, question.modelType, $scope.clinic.id, responseText)
      .then(() => {
        $scope.$emit('reloadClinic');
      })
      .finally(() => {
        $scope.waitingQuestionResponse = false;
      });
  };

  $scope.checkEmail = function(email) {
    if (!email || !OCValidationUtil.isValidEmail(email)) {
      return 'Please enter a valid email address.';
    }
  };

  $scope.updateEmail = function() {
    var err = $scope.checkEmail($scope.clinic.email);
    if (err) {
      return err;
    }
    return ClinicService.updateClinic($scope.clinic, {
      email: $scope.clinic.email,
    }).then(function() {
      $scope.$emit('reloadClinic');
    });
  };

  $scope.resendEmailVerification = function($event) {
    $event.stopPropagation();
    return UserService.sendEmailVerification($scope.clinic.email);
  };

  $scope.needPhoneVerification = function() {
    return !($scope.clinic.phoneVerified && $scope.clinic.phone == $scope.clinicPhone());
  };

  $scope.clinicPhone = function(formatted) {
    var phone = PhoneUtils.formatPhoneNumber($scope.userEntered.phoneNumber);
    phone += $scope.userEntered.phoneExtension ? 'x' + $scope.userEntered.phoneExtension : '';

    if (formatted) {
      phone = $filter('phone')(phone);
    }

    return phone;
  };

  $scope.saveHours = function(hours) {
    return ClinicService.updateClinic($scope.clinic, {
      hours,
    }).then(function() {
      $scope.hoursEditMode = false;
    });
  };

  $scope.cancelHoursEditing = function() {
    $scope.hoursEditMode = false;
  };

  $timeout(function() {
    map = OCMapUtil.newMap($document.find('#js-clinic-map')[0], $scope.clinic.latitude, $scope.clinic.longitude);
    if (!map) {
      return;
    }
    marker = OCMapUtil.addMarker(map, $scope.clinic.latitude, $scope.clinic.longitude);
  });

});
